export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5621.dd78daa8.jpg";